import { PageHeader, TabsComponent } from '@/components/molecules'
import { FONT_SIZE } from '@/utils/constants/globalStyle'
import { OverviewTab, TierTab } from '@/containers/ClubPlus/Tabs'
import { useIntl } from 'react-intl'


export const ClubPlusHome = () => {
  const { formatMessage } = useIntl()

  const tabList = [
    { id: 'overview', tabLabel: formatMessage({ id: 'CLUB_PLUS.TIER_OVERVIEW_TAB_LABEL' }), title: formatMessage({ id: 'CLUB_PLUS.TIER_OVERVIEW_TAB_LABEL' }), tabComponent: <OverviewTab /> },
    { id: 'bronze', tabLabel: formatMessage({ id: 'CLUB_PLUS.TIERS_BRONZE_TAB_LABEL' }), title: formatMessage({ id: 'CLUB_PLUS.TIERS_BRONZE_TAB_LABEL' }), tabComponent: <TierTab tierID="bronze" /> },
  ]

  return (
    <section>
      <PageHeader title={formatMessage({ id: 'CLUB_PLUS.TITLE' })} fontSize={FONT_SIZE.XXXL} />
      <TabsComponent tabList={tabList} />
    </section>
  )
}
